const SEARCH_PARAMETER_NAME_DEFAULT_LANGUAGE = 'lang'

export function init(weglotApiKey) {
  const defaultLangeage = new URL(location.href).searchParams.get(SEARCH_PARAMETER_NAME_DEFAULT_LANGUAGE)

  Weglot.on('initialized', () => {
    // if webplay is not inside iframe
    // and if default language is skipped (or has invalid value) then reset weglot translation
    const isIframe = window.self !== window.top
    if (!isIframe && Weglot.getAvailableLanguages().every(x => x !== defaultLangeage)) {
      Weglot.switchTo(Weglot.options.language_from)
    }
  })

  Weglot.initialize({
    api_key: weglotApiKey,
    hide_switcher: true,
  })
}
